import React from 'react';
import {
  Avatar,
  Box,
  CircularProgress,
  Typography,
  alpha,
  useTheme
} from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import RemoveIcon from '@mui/icons-material/Remove';

export type StatTrend = 'up' | 'down' | 'neutral';

interface StatWidgetProps {
  title: string;
  value: number | string;
  icon: React.ReactElement;
  color?: string;
  visible?: boolean;
  subtitle?: React.ReactNode;
}

const trendIconMap: Record<StatTrend, React.ReactNode> = {
  up: <ArrowUpwardIcon color="success" fontSize="small" />,
  down: <ArrowDownwardIcon color="error" fontSize="small" />,
  neutral: <RemoveIcon color="disabled" fontSize="small" />,
};

const StatWidget = ({
  title,
  value,
  icon,
  color = '#000',
  visible = true,
  subtitle
}: StatWidgetProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        p: 2,
        backgroundColor: alpha(color, 0.08),
        borderRadius: 2,
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: 2
      }}
    >
      <Avatar
        sx={{
          width: theme.spacing(6),
          height: theme.spacing(6),
          color: color,
          backgroundColor: alpha(color, 0.15)
        }}
      >
        {icon}
      </Avatar>
      <Box>
        <Typography variant="subtitle2" color="text.secondary" noWrap>
          {title}
        </Typography>
        <Typography
          variant="h5"
          sx={{
            color: color,
            fontWeight: 'bold'
          }}
        >
          {visible ? value : <CircularProgress size={20} />}
        </Typography>
        {subtitle && (
          <Box mt={0.5}>{subtitle}</Box>
        )}
      </Box>
    </Box>
  );
};

export default StatWidget; 